import { get } from 'lodash/get'
import { handleError } from 'helper/rest'
import { clientPublic } from 'helper/axios'

export const getResultProjectCategory = async ({
  project_group_id,
  company_id,
  token,
}) => {
  try {
    return await clientPublic
      .get(
        `projectgroup?&level=${2}&level_id=${project_group_id}&company_id=${company_id}&limit=99`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
